/**
 * 统一处理flowPond
 * flowPond用途：1.打点参数 2.页面跳转需要透传该参数
 */
import { getQueryofKey, getQueryString } from './getUrlParams'
import { channelClickIdConfig } from '../src/outApp/get-clickId'
function setFlowPond(actInfo) {
  let flowPond = getQueryofKey('flowPond')
  if (flowPond) {
    flowPond = decodeURIComponent(flowPond)
    try {
      flowPond = JSON.parse(flowPond) || {}
    } catch (err) {
      flowPond = {}
    }
  }
  flowPond = flowPond || {}
  let query = getQueryString()
  const arr = ['psid', 'crtvid', 'cuid', 'pvid']
  let arr1 = [
    'lastfrom',
    'logpath',
    'fr',
    'orifrom',
    'flowPond',
    'CUID',
    'iOSVersion',
    'token',
    'channel',
    'isGray',
    'ZYBH5KeyPid',
    'zbkvc',
    'ykvc',
    'vc',
    'city',
    'province',
    'dayivc',
    'cuid',
    'pvc',
    'appId',
    'appid',
    'os',
    'vcname',
    'city',
    'screensize',
    'H5WebPageV',
    'physicssize',
    'deviceW',
    'deviceH',
    'device',
    'hideNativeTitleBar',
    'ZybHideTitle',
    'extdata',
    'answerResult',
  ]
  if (actInfo.source === 2) {
    //如果是端外投放，将不同媒体的clickId对应链接参数排除
    const tfArr = []
    Object.keys(channelClickIdConfig).forEach(key => {
      tfArr.push(channelClickIdConfig[key])
    })
    tfArr.push('call_back_url')
    arr1 = arr1.concat(tfArr)
  }
  Object.keys(query).map(item => {
    if (arr.indexOf(item) > -1 || arr.indexOf(item.toUpperCase()) > -1) {
      // 后续删掉这里的判断
      flowPond[item.toUpperCase()] = query[item] || flowPond[item.toUpperCase()]
    } else if (arr1.indexOf(item) === -1) {
      // 'lastfrom', 'logpath', 'fr', 'orifrom'  这几个参数不放到flowPond里面
      flowPond[item] = query[item] || flowPond[item]
    }
  })
  /**
   * orifacId  ---- 来源活动ID
   * 初始活动页的flowPond里的orifacId 为本活动id
   * flowPond里如果有orifacId参数代表该页面不是初始活动页
   * 参数用途：参数透传需要
   * 参数特征：参数一旦赋值，直到成单都不会发生改变
   */
  flowPond['orifacId'] = flowPond['orifacId'] || actInfo.actId
  /**
   * fcid  ---- 活动ID
   * flowPond里的fcid 一直为本活动id，活动跳转 参数值会更新
   * 参数用途：参数透传需要
   * 参数特征：页面跳转到其他蜂鸟活动，会被替换成新的活动id
   */
  flowPond['fcid'] = actInfo.actId
  flowPond['mofangActType'] = actInfo.source
  flowPond['lastpageid'] = window.__PAGE_DATA__.pageInfo.pageId
  return flowPond
}
export default setFlowPond
